/**
 * Bahraini dinar.
 */
export var BHD = {
  code: 'BHD',
  base: 10,
  exponent: 3
};